module.exports = __webpack_public_path__ + "media/recipes/144-3fccb579.png";